/**
 *
 * Asynchronously loads the component for Sap001
 * Author: Anhnt
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
